import React from "react";
import { FlexRowCenter } from "designSystem/index";
import LoadingPlaceholder from "designSystem/components/placeholder/LoadingPlaceholder";

interface LoaderProps {
    label: string;
}

const Loader = ({ label }: LoaderProps) => (
	<FlexRowCenter
		flexGrow={1}
		justifyContent="center"
		px={3}
	>
		<LoadingPlaceholder
			subtitleProps={{ res: "LoadingInProgress", resParams: [label] }}
			titleProps={{ res: "Loading" }}
		/>
	</FlexRowCenter>
);

export default Loader;
